var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.88564 0.688937C6.19334 0.0735361 6.94166 -0.175904 7.55706 0.131796C7.75797 0.232253 7.92722 0.384757 8.04782 0.572325L8.1142 0.688937L13.8683 12.1972C14.176 12.8126 13.9266 13.5609 13.3112 13.8686C13.1814 13.9335 13.0417 13.975 12.8984 13.9917L12.754 14.0001H1.24581C0.557766 14.0001 0 13.4423 0 12.7543C0 12.6093 0.0253292 12.4657 0.0744833 12.33L0.131523 12.1972L5.88564 0.688937ZM7.04747 1.00485C6.96279 0.988109 6.87484 1.01743 6.81714 1.08163L6.78006 1.13615L1.02595 12.6444C1.00888 12.6785 1 12.7161 1 12.7543C1 12.8707 1.08085 12.9681 1.18944 12.9936L1.24581 13.0001H12.754C12.7922 13.0001 12.8298 12.9912 12.864 12.9742C12.9651 12.9236 13.0162 12.8126 12.9953 12.7067L12.9739 12.6444L7.21977 1.13615C7.20392 1.10444 7.18149 1.07672 7.1542 1.05472L7.10985 1.02622L7.04747 1.00485ZM6.99992 10.5001C7.27606 10.5001 7.49992 10.724 7.49992 11.0001C7.49992 11.2763 7.27606 11.5001 6.99992 11.5001C6.72378 11.5001 6.49992 11.2763 6.49992 11.0001C6.49992 10.724 6.72378 10.5001 6.99992 10.5001ZM6.99992 4.50011C7.24538 4.50011 7.44953 4.67698 7.49186 4.91023L7.49992 5.00011V9.14081C7.49992 9.41695 7.27606 9.64081 6.99992 9.64081C6.75446 9.64081 6.55031 9.46393 6.50797 9.23069L6.49992 9.14081V5.00011C6.49992 4.72397 6.72378 4.50011 6.99992 4.50011Z",
    fill: "#662B0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.b40335e659869c71874b75305f2e070b.svg";
export { ForwardRef as ReactComponent };